import { Link } from "react-router-dom";

/**
 * Logo: B mark (logo copy.svg) + two-line wordmark (Bespokian header style).
 */
export function Logo({ variant = "dark" }: { variant?: "dark" | "light" }) {
  const isLight = variant === "light";
  return (
    <Link
      to="/"
      className="flex items-center gap-3 group"
      aria-label="Bespokian Auto – Home"
    >
      <img src="/logo%20copy.svg" alt="" className="h-10 w-auto" aria-hidden />
      <div className="flex flex-col">
        <span
          className={[
            "font-headline text-xl tracking-wide font-semibold",
            isLight ? "text-white" : "text-navy-900",
          ].join(" ")}
        >
          BESPOKIAN
        </span>
        <span
          className={[
            "text-[10px] tracking-[0.3em] uppercase -mt-1",
            isLight ? "text-white/80" : "text-muted-navy",
          ].join(" ")}
        >
          AUTO
        </span>
      </div>
    </Link>
  );
}
